<div class="tile-padding-first tile-padding">
  <form [formGroup]="form">
    <div class="flex-search-container filter-bar">
      <div class="filter-bar__group">
        <div class="filter-bar__field">
          <div class="filter-bar__label">Report Types</div>
          <app-searchable-select formControlName="reports" [items]="reportDataService.reports"
            displayField="name" placeholder="Select a report type"
            searchPlaceholder="Search report types…"></app-searchable-select>
        </div>
        <div class="filter-bar__field">
          <div class="filter-bar__label tw:flex tw:justify-between tw:items-center">
            <span>{{ multiClient ? 'Clients' : 'Client' }}@if (multiClient && clientIds.length > 0) { ({{ clientIds.length }}) }</span>
            <label class="several-clients" data-test="several-clients">
              <input type="checkbox" [checked]="multiClient" (change)="setMultiClient($any($event.target).checked)"> Several clients
            </label>
          </div>
          @if (multiClient) {
            <app-searchable-select formControlName="clients" [items]="reportDataService.clientList"
              displayField="dropdownDisplay" valueField="clientId" multiple
              placeholder="Select clients" searchPlaceholder="Search clients…"></app-searchable-select>
          } @else {
            <app-searchable-select formControlName="clients" [items]="reportDataService.clientList"
              displayField="dropdownDisplay" valueField="clientId"
              placeholder="Select a client" searchPlaceholder="Search clients…"></app-searchable-select>
          }
        </div>
        <div class="filter-bar__field">
          <div class="filter-bar__label">Start Date</div>
          <input type="date" class="field__control" formControlName="startDate" required (input)="datePreset = null"
            title="Please select a start date">
        </div>
        <div class="filter-bar__field">
          <div class="filter-bar__label">End Date</div>
          <input type="date" class="field__control" formControlName="endDate" required (input)="datePreset = null"
            title="Please select an end date">
        </div>
        @if (showMoreOptions) {
        <div class="filter-bar__field">
          <div class="filter-bar__label">Tuition Coordinator</div>
          <app-searchable-select formControlName="coordinators" [items]="reportDataService.coordinatorList"
            displayField="name" valueField="id" placeholder="Select a tuition coordinator"
            searchPlaceholder="Search coordinators…"></app-searchable-select>
          <app-report-lookup-note lookup="coordinators" label="coordinators"></app-report-lookup-note>
        </div>
        <div class="filter-bar__field">
          <div class="filter-bar__label">Tutors</div>
          <app-searchable-select formControlName="tutors" [items]="reportDataService.tutorList"
            displayField="name" valueField="id" placeholder="Select a tutor"
            searchPlaceholder="Search tutors…"></app-searchable-select>
          <app-report-lookup-note lookup="tutors" label="tutors"></app-report-lookup-note>
        </div>
        <div class="filter-bar__field">
          <div class="filter-bar__label">Learners</div>
          <app-searchable-select formControlName="students" [items]="reportDataService.studentList"
            displayField="name" valueField="id" multiple
            placeholder="Select a learner" searchPlaceholder="Search learners…"></app-searchable-select>
          <app-report-lookup-note lookup="students" label="learners"></app-report-lookup-note>
        </div>
        @if (brandList.length > 1) {
          <div class="filter-bar__field">
            <div class="filter-bar__label">Brand</div>
            <app-searchable-select formControlName="brands" [items]="brandList"
              displayField="name" valueField="companyId" multiple
              placeholder="All brands" searchPlaceholder="Search brands…"></app-searchable-select>
          </div>
        }
        @if (showStatusFilter) {
          <div class="filter-bar__field">
            <div class="filter-bar__label">Session status</div>
            <app-searchable-select formControlName="statuses" [items]="sessionStatusList"
              displayField="name" valueField="id" multiple
              placeholder="All statuses" searchPlaceholder="Search statuses…"></app-searchable-select>
          </div>
        }
        }
      </div>
      <div class="filter-bar__actions">
        <div class="filter-bar__presets">
          <app-date-presets [selected]="datePreset" (presetSelected)="onDatePreset($event)"></app-date-presets>
        </div>
        <div class="filter-bar__buttons">
          <app-filter-clear-all (clear)="clearAll()"></app-filter-clear-all>
          @if (showFormat) {
            <app-report-format-picker testId="combined-format" [inline]="true" [(format)]="format"
              [pdfAvailable]="isNativeReportSelected"></app-report-format-picker>
          }
          @if (canDownload) {
            <button class="btn btn-primary" type="button" data-test="combined-download"
              [disabled]="form.invalid || !isNativeReportSelected || preparingPdf"
              [title]="isNativeReportSelected ? '' : 'This report type has no download'"
              (click)="download()">{{ downloadLabel }}</button>
          }
          @if (canSend) {
            <button class="btn btn-primary" type="button" data-test="combined-send"
              [disabled]="!sendReady" (click)="prepareSend()">{{ sendLabel }}</button>
          }
        </div>
      </div>
    </div>

  </form>

  @if (preparingPdf) {
    <p class="field__hint" data-test="pdf-preparing">Preparing your PDF, it will download when ready</p>
  }
  @if (loadingLines) {
    <p class="field__hint" data-test="send-loading">Finding the bookings to send for…</p>
  }
  @if (noLinesToSend) {
    <p class="field__hint" data-test="send-nothing">No bookings need this report for the selection, so there is nothing to send.</p>
  }

  <section class="combined-preview" data-test="preview" [attr.data-state]="preview">
    @switch (preview) {
      @case ('pick') { <p class="field__hint">Pick a report type and a client to see the report.</p> }
      @case ('several-clients') { <p class="field__hint" data-test="preview-several">Several clients: Send makes one report per client in a single batch. Untick Several clients to see or download one client's report.</p> }
      @case ('no-view') { <p class="field__hint">This report type has no on-screen view.</p> }
      @case ('loading') { <p class="field__hint">Loading the report…</p> }
      @case ('error') { <p class="field__hint" data-test="preview-error">The report couldn't be loaded. Change a filter to try again.</p> }
      @case ('ready') {
        @if (previewRows && previewTotalRows > previewRowLimit) {
          <p class="field__hint" data-test="preview-capped">Showing the first {{ previewRowLimit }} of {{ previewTotalRows }} rows. Download has the whole report.</p>
        }
        @switch (previewCode) {
          @case ('attendance') { <attendance-report [rows]="previewRows"></attendance-report> }
          @case ('cohortprogress') { <cohort-progress-report [rows]="previewRows"></cohort-progress-report> }
          @case ('progressoverview') { <progress-overview-report [rows]="previewRows"></progress-overview-report> }
          @case ('milpr') { <milpr-report [report]="previewMilpr"></milpr-report> }
        }
      }
    }
  </section>

  <mat-expansion-panel class="already-sent" data-test="already-sent" [expanded]="false">
    <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
      <mat-panel-title>
        Already sent for this selection
        @if (form.value.reports && !alreadySentLoading) {
          @if (lastSent) {
            <span class="tw:ml-2 field__hint" data-test="last-sent">last sent {{ lastSent | date: 'd MMM yyyy, HH:mm' }}
              ({{ alreadySent.length }}{{ alreadySent.length === 10 ? '+' : '' }})</span>
          } @else {
            <span class="tw:ml-2 field__hint">(none yet)</span>
          }
        }
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="already-sent__head">
      <a href="" data-test="see-all-history" (click)="$event.preventDefault(); seeAllInHistory()">See all in History</a>
    </div>
    @if (!form.value.reports) {
      <p class="field__hint">Pick a report type to see what has already been sent.</p>
    } @else if (alreadySentLoading) {
      <p class="field__hint">Loading…</p>
    } @else if (alreadySent.length === 0) {
      <p class="field__hint" data-test="already-sent-empty">Nothing sent for this selection yet.</p>
    } @else {
      <table class="already-sent__table">
        <thead><tr><th>Generated</th><th>Client</th><th>Learner</th><th>Report type</th><th>Delivery</th></tr></thead>
        <tbody>
          @for (row of alreadySent; track row.generatedReportId) {
            <tr>
              <td>{{ row.generatedDate | date: 'd MMM yyyy, HH:mm' }}</td>
              <td>{{ row.clientName }}</td>
              <td>{{ row.studentName }}</td>
              <td>{{ row.reportType }}</td>
              <td>{{ row.deliveryStatus || '—' }}</td>
            </tr>
          }
        </tbody>
      </table>
    }
  </mat-expansion-panel>
</div>
